export default "__VITE_ASSET__Cw4TFEWB__"